import { type FC, useEffect, useState } from 'react';

import {
  Button,
  TextBlock,
  type TCookieConsentTexts,
  useAdaptive,
} from '@skillarea/lib-frontend';

import styles from './CookieConsent.module.scss';

const COOKIE_ACCEPTED_STORAGE_KEY = 'cookieAccepted';

interface ICookieConsentProps {
  texts: TCookieConsentTexts;
}

export const CookieConsent: FC<ICookieConsentProps> = ({ texts }) => {
  const { isMobile } = useAdaptive();
  const [isHydrated, setIsHydrated] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    setIsAccepted(
      window.localStorage.getItem(COOKIE_ACCEPTED_STORAGE_KEY) === 'true',
    );
    setIsHydrated(true);
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem(COOKIE_ACCEPTED_STORAGE_KEY, 'true');
    setIsAccepted(true);
  };

  if (!isHydrated || isAccepted) {
    return null;
  }

  return (
    <section
      aria-label={texts.title}
      className={styles.cookieConsent}
      data-testid="cookie-consent"
    >
      <div className={styles.content}>
        <h2 className={styles.title}>{texts.title}</h2>
        <TextBlock className={styles.description} color="secondary">
          {texts.text}
        </TextBlock>
      </div>

      <Button
        className={styles.acceptButton}
        color="accent"
        onClick={handleAccept}
        size="s"
        type="button"
        variant="filled"
      >
        {isMobile ? texts.acceptMobile : texts.accept}
      </Button>
    </section>
  );
};
